import type { PluggableList } from 'unified';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import { rehypeMermaidBlocks } from './rehypeMermaidBlocks';
import { qetaSanitizeSchema } from './qetaSanitizeSchema';

// Passed directly as the `rehypePlugins` prop of `<QetaPage>`. QetaPage renders its own
// internal <QetaProvider> using exactly these props — wrapping QetaPage from the outside
// with a separate <QetaProvider> does NOT work, since that inner provider always shadows it.
export const qetaRehypePlugins: PluggableList = [
  rehypeRaw,
  rehypeMermaidBlocks,
  [rehypeSanitize, qetaSanitizeSchema],
];
